// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"4774":"c1383c32","8512":"d8956386","8847":"92e7ea31"}[chunkId] + ".css";
};